import React, { useState } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import ColoredButton from 'components/ColoredButton';
import general_messages from 'messages/general_messages';
import processing_activities_messages from 'messages/processing_activities_messages';
import validation_messages from 'messages/validation_messages';

type ProcessingActivityPublishDialogProps = {
  loading?: boolean;
  onClose: () => void;
  onConfirm: (changeComment: string) => void;
  open: boolean;
};

const ProcessingActivityPublishDialog: React.FC<ProcessingActivityPublishDialogProps> = ({ loading = false, onClose, onConfirm, open }) => {
  const { t } = useTranslation();
  const [changeComment, setChangeComment] = useState('');
  const [error, setError] = useState('');

  const handleClose = () => {
    setChangeComment('');
    setError('');
    onClose();
  };

  const handleConfirm = () => {
    if (!changeComment.trim()) {
      setError(t(validation_messages.required));
      return;
    }

    onConfirm(changeComment.trim());
    setChangeComment('');
    setError('');
  };

  return (
    <Dialog fullWidth maxWidth='sm' onClose={handleClose} open={open}>
      <DialogTitle>{t(processing_activities_messages.editor.publish_dialog.title)}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          error={Boolean(error)}
          fullWidth
          helperText={error || t(processing_activities_messages.editor.publish_dialog.help)}
          label={t(processing_activities_messages.editor.publish_dialog.change_comment)}
          multiline
          onChange={event => {
            setChangeComment(event.target.value);
            if (error) setError('');
          }}
          rows={4}
          value={changeComment}
          variant='outlined'
        />
      </DialogContent>
      <DialogActions>
        <ColoredButton
          className=''
          customColor='grey'
          disabled={loading}
          icon={false}
          onClick={handleClose}
          showLoader={false}
          textLike={false}
          variant='outlined'
        >
          {t(general_messages.cancel)}
        </ColoredButton>
        <ColoredButton
          className=''
          customColor='secondary'
          disabled={loading}
          icon={false}
          onClick={handleConfirm}
          showLoader={loading}
          textLike={false}
          variant='contained'
        >
          {t(processing_activities_messages.editor.actions.publish_and_close)}
        </ColoredButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProcessingActivityPublishDialog;
